module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am212-3e717c2fc994f2cd7050dea4ce5f5bd7.jpg";